<template>
    <div class="card-main">
        <div class="card-header">
            <img :src="`/internacional/public/office5/img/general-png/world.jpg`">
            <div class="card-title">
                {{ view.translation.select_your_country }}
            </div>
        </div>
        <div class="card-body">
            <modal-multiselect class="select-country" :view="subsidiaries" :translation="view.translation" :getDefaultCountry="DefaultCountry" :getCountry="getCountry" />
            <div class="chose-your-region">
                <div class="card-title subtitle">
                    {{ view.translation.chose_your_timezone }}
                </div>
                <div class="chose-region">
                    <button class="open-select" @click="showSelectOptions = !showSelectOptions">
                        <div class="top-content">
                            <input type="search" v-model="search" :placeholder="searchTimezoneByValue(timezone)"/>
                            <transition name="component-fade" mode="out-in">
                                <div v-if="!showSelectOptions" key="bottom">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#999" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
                                    </svg>
                                </div>
                                <div v-else key="top">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="#999" class="bi bi-caret-up-fill" viewBox="0 0 16 16">
                                        <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/>
                                    </svg>
                                </div>
                            </transition>
                        </div>
                        <div class="bottom-line" />
                    </button>
                    <div class="region-structure" v-show="showSelectOptions">
                        <timezoneSelect v-for="(group, index) in timeZones" :key="index" :view="group" :closeCollapses="closeCollapses" :saveTimezone="saveTimezone" :search="searching" />
                    </div>
                </div>
            </div>
            <hr class="separator"/>
            <form class="submit-btn" method="POST" :action="view.handler_routes.rota_office_set_subsidiary+parameters" @click="sendData()">
                <span>{{ view.translation.continue }}</span>
                <input type="hidden" name="subsidiary" :value="countrySelected">
                <input type="hidden" name="timezone" :value="timezone">
                <!-- <input type="hidden" class="origin-url" name="origin-url" :value="view.handler_routes.rota_office_dashboard_training_second_step"> -->
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "subsidiary-modal-v5",
    props: {
        view: {
            type: Object,
            required: true
        },
        timezones: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            DefaultCountry: null,
            subsidiaries: this.view.subsidiaries,
            countrySelected: null,
            userLang: (navigator.language || navigator.userLanguage || view.lang).substr(-2),
            showSelectOptions: false,
            timezone: typeof moment != 'undefined' && typeof moment.tz == 'function' ? moment.tz.guess() : 'UTC',
            timeZones: [],
            search: null,
            searching: false,
            allTimeZones: null,
            parameters: '',
        }
    },
    created() {
        this.searchByIP()
        this.mountTimeZones()
        this.preSelect()
        this.setParameter()
    },
    mounted() {
        this.sendData()
    },
    methods: {
        setParameter(){
            let url = window.location.href;
            if(url.indexOf('upgrade') != -1)
            {
                this.parameters = '?upgrade=1';
            }

            const params = new URLSearchParams(window.location.search);
            const forward_params = ['domain-purchase', 'term', 'domain', 'period', 'privacy-protection'];

            forward_params.forEach((param) => {
              if (params.get(param)) {
                let sign = this.parameters == '' ? '?' : '&';
                this.parameters+=`${sign}${param}=${params.get(param)}`
              }
            });

        },
        searchByIP() {
            var vm = this;
            axios
                .get(`${ vm.view.search_locale_by_ip_api }`)
                .then(function(res) {})
                .catch(function(error) {})
                .finally(function(res) {

                    let lang_by_ip = '';
                    if(res && res.hasOwnProperty('country_code')) {
                        lang_by_ip = res.country_code;
                    }

                    vm.setDefaultCountry(lang_by_ip, vm.userLang, vm.view.lang);
                });
        },

        mountTimeZones() {
            for (let a = 0; a < this.timezones.length; a++) {
                this.$set(this.timeZones, a, {
                    label: this.timezones[a].label,
                    options: this.timezones[a].options,
                    collapse: false,
                })
            }
            this.allTimeZones = this.timeZones
        },

        setDefaultCountry(lang_by_ip, userLang, routelang) {
            if (lang_by_ip !== '' && lang_by_ip !== null && typeof lang_by_ip !== 'undefined') {
                this.searchCountry(lang_by_ip)
            }
            if (this.DefaultCountry == null && userLang !== '' && userLang !== null && typeof userLang !== 'undefined') {
                this.searchCountry(userLang)
            }
            if (this.DefaultCountry == null && routelang !== '' && routelang !== null && typeof routelang !== 'undefined') {
                this.searchCountry(routelang)
            }
        },

        searchCountry(subsidiary) {
            for (let i = 0; i< this.subsidiaries.length; i++) {
                if (subsidiary.toLowerCase() == this.subsidiaries[i].iso_code.toLowerCase()) {
                    this.DefaultCountry = this.subsidiaries[i]
                    return;
                }
            }
        },

        sendData() {
            $('.submit-btn').click(function () {
                $(this).submit();
            });
        },

        getCountry(country) {
            this.countrySelected = country.id
        },

        saveTimezone(timezone) {
            this.timezone = timezone
            this.search = null
            this.showSelectOptions = false
        },

        searchZones(val) {
            let value = []
            for (let i = 0; i < this.allTimeZones.length; i++) {
                for (let a = 0; a < this.allTimeZones[i].options.length; a++) {
                    if (this.allTimeZones[i].options[a].value.toLowerCase().includes(val.toLowerCase()) || this.allTimeZones[i].options[a].text.toLowerCase().includes(val.toLowerCase())) {
                        value.push(this.allTimeZones[i].options[a])
                    }
                }
            }
            this.timeZones = value
            this.searching = true
        },

        searchTimezoneByValue(value) {
            let index1 = null
            let index2 = null

            for (let i = 0; i < this.allTimeZones.length; i++) {
                if (this.allTimeZones[i].options) {
                    if ((this.allTimeZones[i].options.findIndex(x => x.value.toLowerCase() == value.toLowerCase())) != '-1') {
                        index1 = i
                        index2 = this.allTimeZones[i].options.findIndex(x => x.value.toLowerCase() == value.toLowerCase())
                        // i = this.allTimeZones.length + 1
                        return this.timeZones[index1].options[index2].text;
                    } else if ((this.allTimeZones[i].options.findIndex(x => x.text.toLowerCase() == value.toLowerCase())) != '-1') {
                        index1 = i
                        index2 = this.allTimeZones[i].options.findIndex(x => x.text.toLowerCase() == value.toLowerCase())
                        // i = this.allTimeZones.length + 1
                        return this.timeZones[index1].options[index2].text;
                    }
                } else {
                    return typeof moment != 'undefined' && typeof moment.tz == 'function' ? moment.tz.guess() : 'UTC'
                }
            }
            return typeof moment != 'undefined' && typeof moment.tz == 'function' ? moment.tz.guess() : 'UTC'
        },

        preSelect() {
            for (let i = 0; i < this.timeZones.length; i++) {
                for (let a = 0; a < this.timeZones[i].options.length; a++) {
                    if (this.timeZones[i].options[a].text.toLowerCase() == this.timezone.toLowerCase() || this.timeZones[i].options[a].value.toLowerCase() == this.timezone.toLowerCase()) {
                        this.timeZones[i].collapse = true
                        this.$set(this.timeZones[i].options, a, {
                            value: this.allTimeZones[i].options[a].value,
                            text: this.allTimeZones[i].options[a].text,
                            selected: true,
                        })
                    }
                }
            }
        },

        closeCollapses(label) {
            let index = this.allTimeZones.findIndex(x => x.label.toLowerCase() == label.toLowerCase())
            this.timeZones[index].collapse = true
            for (let i = 0; i < this.timeZones.length; i++) {
                if (i != index) {
                    this.timeZones[i].collapse = false
                }
            }
        }

    },
    watch: {
        search(newSearch) {
            if (newSearch == null || newSearch.length < 1) {
                this.showSelectOptions = false
                this.timeZones = this.allTimeZones
                this.searching = false
            } else if (newSearch.length > 0){
                this.showSelectOptions = true
                this.searchZones(newSearch)
            }
        }
    }
}
</script>
<style lang="scss">
@import '../../../../scss/extras/_variables';
.card-main {
    width: 100%;
    height: 100%;
    .card-header {
        width: 100%;
        height: 30%;

        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            // height: 70%;
            height: 110px;
        }
        .card-input {
            width: 20%;
            margin-top: .5em;
            display: inline-flex;

            input {
                margin-top: .6%;
                width: 100%;
                line-height: 1.5rem;
                border: 0;
                border-bottom: 1px solid #707070;
            }
            input:placeholder {
                color: rgba(112, 112, 112, 0.46);
            }
            textarea:focus, input:focus, select:focus {
                box-shadow: 0 0 0 0;
                border: 0 none;
                outline: 0;
                border-bottom: 1px solid #707070;
            }
        }
    }
    .card-body {
        width: 100%;
        height: 70%;

        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .separator {
            width: 80%;
            margin-top: 65px;
            margin-bottom: 0px;
            border-top: 1px solid rgba(38, 144, 245, 0.1);
        }

        .select-country {
            width: 90%;
        }

        .subtitle {
            margin: 1rem 0;
        }

        .submit-btn {
            width: 90%;
            height: 3rem;
            background-color: $dv5-color1;
            border-radius: 4px;
            margin-bottom: 1rem;

            display: flex;
            align-items: center;
            justify-content: center;

            font-size: 3rem;
            color: #fff;
            cursor: pointer;

            span {
                font-size: 1.5rem;
            }
        }
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
.chose-your-region {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .chose-region {
        position: relative;
        width: 90%;
        height: 2.3rem;

        font-family: 'Muli';
        font-weight: 900;
        font-family: 1.5rem;

        text-align: center;
        cursor: pointer;

        .open-select {
            width: 100%;
            height: 2.6rem;

            background-color: #f8fafd;
            border-radius: 4px;
            border: 0;

            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .top-content {
                padding: 10px;
                width: 100%;
                display: flex;
                justify-content: space-between;
                input {
                    font-family: 'Muli';
                    color: #546577;
                    font-weight: 100;
                    font-size: 16px;
                    text-transform: capitalize;
                    background-color: transparent;
                    border: none;
                }
                input::placeholder {
                    font-family: 'Muli';
                    color: #546577;
                    font-weight: 100;
                    font-size: 16px;
                    text-transform: capitalize;
                }
                .icon {
                    color: #999999;
                    font-size: 10px;
                    right: 5px;
                }
            }

            .bottom-line {
                width: 100%;
                height: 4px;
                background-color: #f0f3f5;
            }
        }

        .region-structure {
            width: 100%;
            height: auto;
            max-height: 14rem;
            min-height: 9rem;
            overflow: auto;

            position: absolute;
            display: block;
            top: 2.4rem;
            border: 1px solid #e8e8e8;
        }
    }
}
.card-title {
    font-family: $dv5-font1;
    color: #2C3E50;
    // font-weight: bold;
    font-size: 1.6rem;
    margin-top: 10px;
}
.component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .2s ease;
}
.component-fade-enter, .component-fade-leave-to
    /* .component-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}


</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/modal/SubsidiaryModalV5.vue